module.exports = __webpack_public_path__ + "static/racing-2510f73ce9effd4e3507ebe57a7c9eb8.jpg";